import React from "react";
import colorPalette from "../constants/colors";

const Footer = () => {
  return (
    <div
      className="w-[-webkit-fill-available] flex py-4 text-center justify-evenly text-xs flex-wrap gap-2"
      style={{
        ...colorPalette.footer,
      }}
    >
      <p className="text-gray-400">
        COPYRIGHT &copy; 2024 ALL RIGHTS RESERVED BY{" "}
        {process.env.REACT_APP_NAME.toUpperCase()}.
      </p>
      <p className="text-gray-400">
        DESIGNED & DEVELOPED BY{" "}
        <a
          href="https://samsinfosoft.com/"
          target="_blank"
          className="text-bold hover:underline target:blank"
          rel="noreferrer"
          style={{ ...colorPalette.footerQuickLinks }}
        >
          SAMS INFOSOFT PVT. LTD.
        </a>
      </p>
    </div>
  );
};

export default Footer;
